import { OnboardingFormActions } from '../../../enums'
import { SetHasChangesAction } from '../../../types/actions'

export const setHasChanges = (hasChanges: boolean): SetHasChangesAction => ({
  type: OnboardingFormActions.SET_HAS_CHANGES,
  payload: hasChanges
})
